import { EndPoints } from '../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;


export const userByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}`;
export const userSecurityByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/security`;
export const changePhoneNumberUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/changePhoneNumber`;
export const userAddressByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/address`;
export const userAddressByIdWithIdUrl = (id, addressId) => `${SERVER_ADDR_V1}/user/${id}/address/${addressId}`;
export const userByPhoneNumberUrl = (phoneNumber) => `${SERVER_ADDR_V1}/user?filters=PhoneNumber@=${phoneNumber}`;
export const userRepresentativeSelfcareAuthById = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}/auth`;
export const userBillingCustomerIdByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/billingcustomerId`;
export const userSoftDeleteByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/soft`;


export const userRepresentativeSelfcareById = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}`;
export const userRepresentativeSelfcareByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/selfcare/${id}`;



export const userRepresentativesUrlById = (id) => `${SERVER_ADDR_V1}/user/${id}/userRepresentatives`;

export const userRepresentativeAuthByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/${id}`;
export const userRepresentativesUrl = () => `${SERVER_ADDR_V1}/UserRepresentative`;
export const userRepresentativeByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/${id}`;
export const userRepresentativeAdressByIdUrl = (id) => `${SERVER_ADDR_V1}/UserRepresentative/${id}/address`;
export const userRepresentativeAdressIdByIdUrl = (id, addressId) => `${SERVER_ADDR_V1}/UserRepresentative/${id}/address/${addressId}`;
export const userServicesUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/connection`;
export const userServiceByIdUrl = (id, serviceId) => `${SERVER_ADDR_V1}/user/${id}/connection/${serviceId}`;
export const userServicesBatchUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/connection/batch`;
export const userDocumentUrl = (id, fileType, path) => `${SERVER_ADDR_V1}/user/${id}/file${fileType !== undefined ? '/' + fileType : ""}${path !== undefined ? '?path=' + path : ''}`;
export const userDocumentsUrl = (id, path) => `${SERVER_ADDR_V1}/user/${id}/file${path !== undefined ? '?path=' + path : ''}`;
export const userMessageUrl = () => `${SERVER_ADDR_V1}/user/message`;
export const userMessageByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/message`;
export const addPaymentMethodUrl = (id) => `${SERVER_ADDR_V1}/paymentmethods`;
export const validateDiscountCodeUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/discounts`;
export const removePaymentMethodUrl = (id, paymentMethodId) => `${SERVER_ADDR_V1}/paymentmethods/${paymentMethodId}`;
export const getCurrentPricesUrl = (id) => `${SERVER_ADDR_V1}/paymentmethods/${id}/prices`;
export const getSetupIntentUrl = () => `${SERVER_ADDR_V1}/paymentmethods/setupintent`;
export const getSetupIntentByIdUrl = (id) => `${SERVER_ADDR_V1}/paymentmethods/${id}/setupintent`;
export const processPaymentdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/processpayment`;
export const searchServiceUrl = (serviceType, pos, name) => `${SERVER_ADDR_V1}/services/list/${serviceType}${name !== undefined ? '?name=' + name : ''}${pos !== undefined ? '?pos=' + pos : ''}`;
export const updateOnBoardingStepUrl = (step) => `${SERVER_ADDR_V1}/user/onboardingStep?step=${step}`;
export const updateOnBoardingStepByIdUrl = (id, step) => `${SERVER_ADDR_V1}/user/${id}/onBoardingStep?step=${step}`;

export const userShareDocument = (id) => `${SERVER_ADDR_V1}/user/${id}/share`;

export const completeById = (id) => `${SERVER_ADDR_V1}/user/${id}/complete`;
export const getInvoicesUrl = () => `${SERVER_ADDR_V1}/invoices`;
export const getInvoicesByUserIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/invoices`;
export const getRecipientInvoicesByIdUrl = (id) => `${SERVER_ADDR_V1}/Invoices/recipient/${id}/USER`;


export const declareDeathById = (id) => `${SERVER_ADDR_V1}/user/${id}/declareDeath`;
export const userServiceDataUrl = (id, serviceType, lifeEvent) => `${SERVER_ADDR_V1}/user/${id}/serviceData${serviceType !== undefined ? "?serviceType=" + serviceType : ""}${lifeEvent !== undefined ? "?lifeEvent=" + lifeEvent : ""}`;
export const getPartnerCustomizationUrl = (partnerId) => `${SERVER_ADDR_V1}/partners/${partnerId}/customization`;

export const addPaymentMethodIntents = (userId, secret) => `${SERVER_ADDR_V1}/paymentmethods/${userId}/paymentIntents/${secret}`;

export const getUserLifeEventsByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/lifeEvents`;
export const declareRelocationByIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/declareRelocation`;

export const generatePrintFile = (id) => `${SERVER_ADDR_V1}/user/${id}/print`;